module.exports = __webpack_public_path__ + "img/staff.ddaf3dd5.jpg";